import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_projects_tabs = _resolveComponent("backer-center-projects-tabs")
  const _component_skeleton_card = _resolveComponent("skeleton-card")
  const _component_backer_center_project_recommendations_section = _resolveComponent("backer-center-project-recommendations-section")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_base_button = _resolveComponent("base-button")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")
  const _component_filter_view = _resolveComponent("filter-view")
  const _component_backer_center_layout = _resolveComponent("backer-center-layout")

  return (_openBlock(), _createBlock(_component_backer_center_layout, {
    size: "narrow",
    title: _ctx.Resources.BackerCenter.SectionProjectsHeader,
    "current-view": "projects"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_filter_view, {
        filters: $setup.projectsFilters,
        "hidden-filter-keys": ['projectInteractionTypes'],
        "hidden-selected-keys": ['projectInteractionTypes'],
        "filter-list-title": _ctx.Resources.Search.SearchFiltersHeader,
        "sort-list-title": _ctx.Resources.Search.SearchProjectSortTitle
      }, {
        header: _withCtx(({ filters, onFilterChange }) => [
          _createVNode(_component_backer_center_projects_tabs, {
            class: "_mb-4",
            "current-search-type": filters.searchParams.value.projectInteractionTypes,
            onTabSelected: (type) => onFilterChange('projectInteractionTypes', type)
          }, null, 8 /* PROPS */, ["current-search-type", "onTabSelected"])
        ]),
        default: _withCtx(({ isProcessing, canLoadMore, loadMore, isLoadingMore }) => [
          isProcessing
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass($options.cardListWrapperClass),
                "data-qa": "backer-center-view-projects:Skeleton"
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (placeholder) => {
                  return _createElementVNode("div", { key: placeholder }, [
                    _createVNode(_component_skeleton_card, { class: "_h-full" })
                  ])
                }), 64 /* STABLE_FRAGMENT */))
              ], 2 /* CLASS */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                ($options.hasProjects)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", {
                        class: _normalizeClass($options.cardListWrapperClass)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mainProjectItems, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.props.projectID,
                            "data-qa": `search-result-project:${item.props.projectID}`
                          }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), _mergeProps({ ref_for: true }, item.props), null, 16 /* FULL_PROPS */))
                          ], 8 /* PROPS */, _hoisted_1))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 2 /* CLASS */),
                      _createVNode(_component_backer_center_project_recommendations_section, {
                        class: "_my-6",
                        "data-qa": 'Recommendations'
                      }),
                      _createElementVNode("div", {
                        class: _normalizeClass($options.cardListWrapperClass)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.remainingProjectItems, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.props.projectID,
                            "data-qa": `search-result-project:${item.props.projectID}`
                          }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), _mergeProps({ ref_for: true }, item.props), null, 16 /* FULL_PROPS */))
                          ], 8 /* PROPS */, _hoisted_2))
                        }), 128 /* KEYED_FRAGMENT */)),
                        isLoadingMore
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (placeholder) => {
                              return _createElementVNode("div", { key: placeholder }, [
                                _createVNode(_component_skeleton_card, { class: "_h-full" })
                              ])
                            }), 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        canLoadMore
                          ? (_openBlock(), _createBlock(_component_load_more_trigger, {
                              key: 1,
                              onLoadMore: loadMore
                            }, null, 8 /* PROPS */, ["onLoadMore"]))
                          : _createCommentVNode("v-if", true)
                      ], 2 /* CLASS */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_box, { class: "_mt-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_empty_state, {
                            title: _ctx.Resources.Search.SearchProjectsResultsEmptyStateTitle,
                            description: _ctx.Resources.Search.SearchProjectsResultsEmptyStateParagraph,
                            "data-qa": "backer-center-view-projects:EmptyState"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_base_button, {
                                tag: "a",
                                href: $options.searchUrl,
                                icon: "search",
                                theme: "accent",
                                class: "_mt-3",
                                "data-qa": "backer-center-view-projects:ExploreProjects"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.UpdatesFeedEmptyStateButtonLabel), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["href"])
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["title", "description"])
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_backer_center_project_recommendations_section, {
                        class: "_mt-6",
                        "data-qa": 'Recommendations'
                      })
                    ], 64 /* STABLE_FRAGMENT */))
              ], 64 /* STABLE_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["filters", "filter-list-title", "sort-list-title"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title"]))
}